import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useKpFilterStore } from '@/stores/KpFilterStore'
import { Project } from '@/server/MakeSenseApp-backend'

export const useProjectStore = defineStore('project', () => {
  const noProjects = ref<boolean>(false)
  const projectHasBeenSet = ref<boolean>(false)
  const projectId = ref<string>('')
  const selectedProject = ref<Project | undefined>(undefined)
  const kpStore = useKpFilterStore()
  const refreshCounter = ref<number>(0)

  function refreshData() {
    refreshCounter.value = refreshCounter.value + 1
  }

  function setProject(project: Project | undefined) {
    projectId.value = project?.id ?? ''
    projectHasBeenSet.value = true
    selectedProject.value = project ?? undefined
    kpStore.resetMinMax()
  }

  function setNoProjects() {
    noProjects.value = true
  }

  return {
    setNoProjects: setNoProjects,
    setProject: setProject,
    refreshData: refreshData,
    projectHasBeenSet,
    noProjects,
    projectId,
    selectedProject,
    refreshCounter
  }
})
